import React from "react";
import { Route, Switch } from "react-router-dom";

import Supplements from "../containers/supplements";
import BasicDataForm from "../containers/forms/supplements/basic-data/basic-data-form";
import NewInsuredStepperForm from "../containers/forms/supplements/new-insured/newInsuredStepperForm";
import WaiverOfWaitingPeriods from "../containers/forms/supplements/waiver-of-waiting-periods/waiver-of-waiting-periods";
import PolicyHolderUnsubscription from "../containers/forms/supplements/policyholder-unsubscription/policyholder-unsubscription";
import policyHolderChangeForm from "../containers/forms/supplements/policy-holder-change-form/policy-holder-change-form";
import { SupplementsProvider } from "../context/supplements/SupplementsProvider";

export const SupplementsRoutes = () => {
  return (
    <SupplementsProvider>
      <Switch>
        <Route path="/suplementos" component={Supplements} />
        <Route path="/suplemento/datos-basicos/:formTitle" component={BasicDataForm} />
        <Route path="/suplemento/alta-asegurado" component={NewInsuredStepperForm} />
        <Route path="/suplemento/exencion-carencia" component={WaiverOfWaitingPeriods} />
        <Route path="/suplemento/baja" component={PolicyHolderUnsubscription} />
        <Route path="/suplemento/cambio-tomador" component={policyHolderChangeForm} />
      </Switch>
    </SupplementsProvider>
  );
};

export default SupplementsRoutes;
